import { render } from "./ApproveDoctorModal.vue?vue&type=template&id=c4adb672&scoped=true"
import script from "./ApproveDoctorModal.vue?vue&type=script&lang=js"
export * from "./ApproveDoctorModal.vue?vue&type=script&lang=js"

import "./ApproveDoctorModal.vue?vue&type=style&index=0&id=c4adb672&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4adb672"]])

export default __exports__